import type {
  GetPreferredDesignersResponseType,
  PreferredDesigner,
} from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { preferredDesignersKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client.ts";

export function useGetPreferredDesigners(projectId?: number) {
  return useQuery<
    GetPreferredDesignersResponseType,
    PreferredDesigner,
    PreferredDesigner[]
  >({
    enabled: !!projectId,
    queryFn: async () =>
      await apiClient
        .url(`/projects/${projectId}/preferred-designers`)
        .get()
        .json(),
    queryKey: preferredDesignersKeys.preferredDesignersByProjectId(projectId),
    select: (data) =>
      data.preferredDesigners.map(({ avatar, id, name }) => ({
        id: id,
        profilePicture: avatar,
        textValue: name,
      })),
  });
}
